import { createSlice } from "@reduxjs/toolkit";
import { sendEmisReoprtAction } from "../Actions/SendEmail";
export const MisReportReducer = createSlice({
    name: "getCityReducer",
    initialState: {
        isLoading: false,
        data: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(sendEmisReoprtAction.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(sendEmisReoprtAction.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(sendEmisReoprtAction.rejected, (state, action) => {
            console.error("Error", action.payload);
            state.isError = true;
            state.isLoading = false;
        });
    },
});